import { SxProps } from '@mui/system'
import { AlertType } from 'src/components/shared/ui/AlertDialog/enums'
import { theme } from 'src/providers/ThemeProvider'
import { colors } from 'src/providers/globalVars'

type DialogElements = {
  alert: SxProps
  content: SxProps
  containerTitle: SxProps
  title: SxProps
  closeButton: SxProps
  buttonsContainer: SxProps
  closeIcon: SxProps
}

const getColorType = (type: AlertType) => {
  switch (type) {
    case AlertType.INFO:
      return colors.byzantineBlue050
    case AlertType.ERROR:
      return colors.persianRed050
    case AlertType.WARNING:
      return colors.saffron050
    case AlertType.SUCCESS:
      return colors.seaGreen050
    default:
      return colors.persianRed050
  }
}

export const AlertStyles = (type: AlertType): DialogElements => {
  const colorType = getColorType(type)

  return {
    alert: {
      '& .MuiDialog-container .MuiDialog-paper': {
        padding: 0,
        borderRadius: '8px',
        boxShadow: '0px 2px 9px 0px rgba(113, 113, 113, 0.25)'
      }
    },

    content: {
      margin: 0,
      padding: '0 10px 16px 10px',
      textAlign: 'center',
      color: theme.colors.gray14,
      fontFamily: theme.corporate.primaryFont,
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '20px',

      '& .MuiContainer-root': {
        padding: '6px 16px'
      },

      '& ul': {
        listStyleType: 'none'
      },

      '& .MuiDialogActions-root': {
        padding: '50px'
      }
    },

    containerTitle: {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: colorType,
      borderRadius: '4px',
      margin: '10px 10px 16px 10px',

      '& .MuiDialogTitle-root': {
        backgroundColor: colorType,
        margin: 0
      }
    },

    title: {
      marginLeft: '20px',
      fontSize: '20px'
    },

    closeButton: {
      position: 'absolute',
      right: 8,
      color: colors.white01
    },

    buttonsContainer: {
      margin: 0,
      padding: '0 10px 10px 10px',

      '& .MuiDialogActions-root': {
        padding: 0
      },

      '& .MuiButton-root': {
        height: 38
      }
    },

    closeIcon: {
      fontSize: '16px',
      marginRight: '10px'
    }
  }
}
